/* Koreachi | sticky-atc.js — reveal mobile add-to-cart bar after hero scrolls out */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var hero = document.querySelector('.hero') || document.querySelector('.pdp-gallery');
  if (!hero) return;

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { rootMargin: '-40% 0px 0px 0px' });
    io.observe(hero);
  }

  // If the CTA points to #buy, let it smooth-scroll; otherwise open cart drawer.
  var cta = bar.querySelector('[data-sticky-cta]');
  if (cta && cta.getAttribute('href') === '#buy') {
    cta.addEventListener('click', function () {
      var buy = document.getElementById('buy');
      if (buy) {
        var atc = buy.querySelector('[data-atc]');
        if (atc) setTimeout(function () { atc.focus({ preventScroll: true }); }, 600);
      }
    });
  }
})();
